module.exports = __webpack_public_path__ + "static/media/tmp.b5f812c0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/tmp.mp4
// module id = 75
// module chunks = 0